export default [
  {
    path: '',
    name: 'currency list',
    component: () => import('@/views/app/currency/list/page-list.vue'),
    meta: { title: 'Daftar Mata Uang' },
  },
]
